// PRD 20 §4.1 display format: "YYYY.MM.DD". Null → "-".
const pad = (n: number) => String(n).padStart(2, '0');

export function formatProfileDate(iso: string | null): string {
  if (!iso) return '-';
  const d = new Date(iso);
  return `${d.getFullYear()}.${pad(d.getMonth() + 1)}.${pad(d.getDate())}`;
}
